import NotificacaoMixin from 'src/core/mixin/NotificacaoMixin'

// DpGridMixin // so para grid
export default {
  mixins: [NotificacaoMixin]
}
